<template>
<div class="chapter">
<div class="inner_page">
<p class="C124"><a id="page_1">THE GREAT MOVIES III</a></p><a id="page_1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Halftitle_Page.vue?b1fb121c